import React from "react";

export function Arrow({ diagonal = false, ...props }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path
        d={diagonal ? "M6 18 18 6M6 6h12v12" : "M4 12h15m-6-6 6 6-6 6"}
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Mark() {
  return (
    <svg
      className="site-mark"
      width="36"
      height="36"
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M10 17.5V46.5M49.6 21.4A15 15 0 1 0 53.3 36.7V32H45"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <path
        d="M10 32h13"
        stroke="var(--accent)"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <rect
        x="20"
        y="28"
        width="8"
        height="8"
        rx="1"
        transform="rotate(45 24 32)"
        fill="var(--accent)"
      />
    </svg>
  );
}
